import React from 'react'
import PropTypes from 'prop-types'
import { cpfCnpj, simpleStrDate } from 'utils/format'
import { DescItemInfo } from 'ui-components/DescItemInfo'
import { Card } from 'ui-components/Card'
import { CardTitle } from 'ui-components/CardTitle'

export default function BasicInfo({ customer }) {
  return (
    <Card>
      <CardTitle title="Dados básicos" noMargin />
      <DescItemInfo label="Nome">
        {customer.attributes.name}
      </DescItemInfo>
      <DescItemInfo label="E-mail">
        {customer.attributes.email}
      </DescItemInfo>
      <DescItemInfo label="CPF/CNPJ">
        {cpfCnpj(customer.attributes.document1)}
      </DescItemInfo>
      <DescItemInfo label="Data de nascimento">
        {simpleStrDate(customer.attributes.birthdate)}
      </DescItemInfo>
    </Card>
  )
}

BasicInfo.propTypes = {
  customer: PropTypes.objectOf(PropTypes.any),
}

BasicInfo.defaultProps = {
  customer: { attributes: {} },
}
